<div class="d-flex flex-column align-items-center gap-2 p-3">
  <i class="mdi mdi-alert-circle-outline text-danger" style="font-size: 56px;"></i>

  <h1 class="fw-bold text-center fs-6 text-dark">{{ data.title }}</h1>
</div>
<div class="preview-container">
  <span>{{ data.message }}</span>
  <button
    class="btn btn-outline-secondary my-3 px-4"
    [mat-dialog-close]="">{{ 'shared.alertModal.closeButton' | translate }}</button>
</div>
